import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import { DEFAULT_BREAKPOINTS_HOME } from 'components/TalentsCarousel/constants/talentCarouselConstants';
//----------------------------------------------------------------------------------------
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import './Carouselmath.scss';
import axios from 'axios';
import MatchCard from './MatchCard';
import {showPlaceHolderorImg} from 'containers/MundialViews/utils/mundialUtils';
import placeholderVcard from 'containers/MundialViews/assets/placeholder/placeholderBigCard.png';
import { FaChevronLeft,FaChevronRight } from 'react-icons/fa';
import moment from 'moment';
import SwiperCommon from './SwiperCommon'


SwiperCore.use([Pagination, Navigation]);

const CarouselMatch = ({
  carrousel,
  breakpointConfig = DEFAULT_BREAKPOINTS_HOME,
}) => {
  const [matches, setMatches] = useState([]);
  const { isMobile } = useVerifyIsMobile(768);
  const [timeFrom, setTimeFrom] = useState('2022-11-20');
  const [timeTo, setTimeTo] = useState('2022-11-30');
  const [hours,setHours] = useState('')

useEffect(()=>{
  const formatTime = moment().format('l').split('/');
  const currentTimeSecond = ((parseInt(formatTime[1])*86400)+(parseInt(formatTime[0])*2592000)+(parseInt(formatTime[2])*31104000))
  if(currentTimeSecond > 62922528000){
    console.log('timeFormat',moment().add(6,'hours').format().split('T')[1].split('-')[0] )
    const timeStart = moment().format().split('T')[0];
    const timeEnd = moment(timeStart).add(10,'day').format().split('T')[0];
    setTimeFrom(timeStart);
    setTimeTo(timeEnd);
    setHours(moment().add(6,'hours').format().split('T')[1].split('-')[0])
  }
},[])

  useEffect(() => {
    axios
      .get(
        `https://gracenoteclaro.akamaized.net/gsd/lookup/v1/leagues/GNA5MGHG2ZVX2RD/schedule-results?timeFrom=${timeFrom}T${hours}&timeTo=${timeTo}T${hours}&language=es-ES&api_key=y368pewmkbqewyaha8xydgc5`,
      )
      .then(res => {
        let filter1 = res.data.matches.filter(a => ((a.awayParticipant.nationality.images.flag && a.awayParticipant.nationality.names.default )&&
        (a.homeParticipant.nationality.images.flag && a.homeParticipant.nationality.names.default )));
        filter1 = filter1.filter(b=> b.status.scheduleStatus !== 'COMPLETED')
        setMatches(filter1);
      })
      .catch(e => console.log(e));
  }, [timeFrom || timeTo]);

  const nameCarousel = carrousel.name.replace(/-/g, ' ');

  const returnCard = ()=>{
    return MatchCard;
  }

  return (
   
    <SwiperCommon title={nameCarousel} matches={matches} Card={returnCard()} />
  );
};

export default CarouselMatch;
